import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  DropdownButton,
  Dropdown as ReactDropdown,
  Image,
  Container,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AppDispatch, RootState } from "../../../redux/store";
import { fetchUploadedDocs } from "../../guestUser/ppApplication/redux/action/fetchUploadedDocs";
import axios from "axios";
import { getSessionId } from "../../../utils/tokenHandlers";
import VerStatusRemarks from "./verStatusRemarks";
import { getVerStatusRemarks } from "../redux/action/getVerStatusRemarks";
import SectionHeading from "../../../components/common/SectionHeading";
import UidEmailRoleMatch from "../../constants/uidEmailRoleMatch";

const KYCVerification: React.FC = () => {
  // const statusRemarksStore =

  const { appId } = useParams();
  const customerId = Number(appId);
  const dispatch = useDispatch<AppDispatch>();
  const [selectedType, setSelectedType] = useState(" Select Type");
  const [verDocId, setVerDocId] = useState(Number);
  const [typeSelected, setTypeSelected] = useState(false);
  const [selectedName, setSelectedName] = useState(" ");
  const [dataUpdated, setDataUpdated] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [docType, setDocType] = useState("");

  const [docObjects, setDocObjects] = useState<
    {
      id: any;
      doc_type: string;
      doc_id: number;
      doc_name: string;
      document_name_fgn: string;
      doc_name_text: string;
      maker_status: string;
      checker_status: string;
    }[]
  >([]);
  const getAppSelector = useSelector(
    (state: RootState) => state.opsPpIndApp.getApp
  );
  const isCounterParty = getAppSelector.data.is_counterparty;
  // const handleDropdownChange = async (docType: string) => {
  //   await fetchDocContent(docType);
  //   handleDocTypeSelect(docType);
  //   await handleVerStatusRemarks();
  // };
  const handleDropdownChange = async (
    selectedDocName: string,
    selectedDocType: string,
    selectedDocId: any
  ) => {
    await fetchDocContent(selectedDocName, selectedDocType);
    setSelectedName(selectedDocName);
    // console.log("selected DOc:", selectedDocName);
    const docObject = docObjects.find(
      (doc) =>
        doc.doc_name_text === selectedDocName &&
        doc.doc_type === selectedDocType &&
        doc.id === selectedDocId
    );
    if (docObject) {
      // console.log("id::", selectedDocId);
      // console.log("Doc Obj:", docObject);
      const docId = docObject.doc_id;
      setVerDocId(selectedDocId);

      setDocNameType(docObject.doc_name);
      const docTypee = docObject.doc_type;
      // // console.warn("boom---", docObject.doc_name);
      // console.warn("document id-->", docTypee);
      handleDocTypeSelect(docTypee);
      await handleVerStatusRemarks(selectedDocId);
    }
    // handleDocTypeSelect(selectedDocName);
    // await handleVerStatusRemarks();
  };

  const handleDocTypeSelect = (docType: string) => {
    setSelectedType(docType);
    localStorage.setItem("selectedType", docType);
    // console.warn("here", localStorage.getItem("selectedType"));
  };

  const updateVerificationStatus = (
    docIdToUpdate: any,
    newMakerStatus: string,
    newCheckerStatus: string
  ) => {
    const updatedDocs = docObjects.map((doc) => {
      if (doc.doc_id === docIdToUpdate) {
        return {
          ...doc,
          maker_status: newMakerStatus,
          checker_status: newCheckerStatus,
        };
      }
      return doc;
    });
    setDocObjects(updatedDocs);
  };

  useEffect(() => {
    const fetchDocsData = async () => {
      localStorage.removeItem("selectedType");
      try {
        const result = await dispatch(fetchUploadedDocs(customerId));
        if (result.payload) {
          // console.warn("success");
          // console.warn(result.payload);
          const documents = result.payload.result.result;
          const docObjects = documents.map(
            (document: {
              id: any;
              document_type: any;
              attachment_ids: any[];
              document_name: any;
              document_name_fgn: any;
              document_name_text: any;
              maker_verification_status: string;
              checker_verification_status: string;
            }) => ({
              id: document.id,
              doc_type: document.document_type,
              doc_id: document.attachment_ids[0],
              doc_name: document.document_name,
              document_name_fgn: document.document_name_fgn,
              doc_name_text: document.document_name_text,
              maker_status: document.maker_verification_status,
              checker_status: document.checker_verification_status,
            })
          );
          setDocObjects(docObjects);

          // console.warn(`Docs Object for ${customerId}`, docObjects);
        }
      } catch (error) {
        // console.error("An error occurred", error);
      }
    };
    fetchDocsData();
  }, [customerId]);

  const refreshVerificationStatus = async () => {
    const result = await dispatch(fetchUploadedDocs(customerId));
    if (result.payload) {
      const documents = result.payload.result.result;
      const updatedDocObjects = documents.map((document: any) => ({
        id: document.id,
        doc_type: document.document_type,
        doc_id: document.attachment_ids[0],
        doc_name: document.document_name,
        document_name_fgn: document.document_name_fgn,
        doc_name_text: document.document_name_text,
        maker_status: document.maker_verification_status,
        checker_status: document.checker_verification_status,
      }));
      setDocObjects(updatedDocObjects);
    }
  };

  const sessionId = getSessionId();
  const [docNameType, setDocNameType] = useState("");
  const [imageData, setImageData] = useState("");
  const [fileType, setFileType] = useState("");
  const fetchDocContent = async (
    selectedDocName: string,
    selectedDocType: string
  ) => {
    setDataUpdated(false);
    setShowSpinner(true);

    const docObject = docObjects.find(
      (doc) =>
        doc.doc_name_text === selectedDocName &&
        doc.doc_type === selectedDocType
    );

    if (docObject) {
      const docId = docObject.doc_id;
      setDocNameType(docObject.doc_name);

      const apiUrl = `${process.env.REACT_APP_BASE_URL}web/read/content/${docId}`;
      const sessionId = getSessionId();
      const UidEmailRole = UidEmailRoleMatch();

      try {
        const response = await axios.post(
          apiUrl,
          {
            params: {
              ...UidEmailRole,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${sessionId}`,
            },
          }
        );

        // ✅ API now returns JSON with result
        const fileString: string = response.data.result;

        if (fileString.startsWith("%PDF")) {
          // Convert string → binary array (safe for older TS targets)
          const byteArray = new Uint8Array(fileString.length);
          for (let i = 0; i < fileString.length; i++) {
            byteArray[i] = fileString.charCodeAt(i);
          }

          const blob = new Blob([byteArray], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);
          setImageData(blobUrl);
          setFileType("pdf");
        } else {
          // Handle image
          const base64Data = btoa(fileString);
          const imageBase64 = `data:image/png;base64,${base64Data}`;
          setImageData(imageBase64);
          setFileType("img");
        }

        setTypeSelected(true);
      } catch (error) {
        console.error("Error fetching doc:", error);
        setTypeSelected(false);
      }

      setShowSpinner(false);
    } else {
      setShowSpinner(false);
    }
  };

  const handleVerStatusRemarks = async (selectedDocId: any) => {
    try {
      const result = await dispatch(
        getVerStatusRemarks({ customerId, selectedDocId })
      );
      if (result.payload) {
        // console.log("in main file-->", result.payload);
        setTimeout(() => {
          setDataUpdated(true);
        }, 500);
      }
    } catch (error) {
      // console.error("An error occurred", error);
    }
  };

  return (
    <>
      <Row>
        <Col md={6}>
          {isCounterParty === false && (
            <DropdownButton
              id="document-type-dropdown"
              title={selectedType}
              variant="outline-primary"
              style={{ marginLeft: "15px" }}
            >
              {[...docObjects]
                .sort((a, b) => a.doc_type.localeCompare(b.doc_type))
                .map((docObject) => {
                  const { maker_status, checker_status } = docObject;

                  let textColor = "";
                  if (maker_status === "Failure") {
                    textColor = "#ca7373ff";
                  } else if (maker_status === "Success") {
                    textColor = "#C2FFC7";
                  }

                  return (
                    <ReactDropdown.Item
                      key={docObject.doc_id}
                      onClick={() => {
                        setDocType(docObject.doc_type);
                        handleDropdownChange(
                          docObject.doc_name_text,
                          docObject.doc_type,
                          docObject.id
                        );
                      }}
                      style={{ backgroundColor: textColor }}
                    >
                      {docObject.doc_type} - {docObject.doc_name}{" "}
                      {docObject.document_name_fgn} - {docObject.doc_name_text}
                    </ReactDropdown.Item>
                  );
                })}
            </DropdownButton>
          )}
        </Col>

        <Col md={6}>
          <p className="m-1">{selectedName}</p>
        </Col>
      </Row>
      <Row className="m-2">
        {isCounterParty === true ? (
          // <p className="mt-3" style={{ color: "#d64161" }}>
          //   KYC IS NOT APPLICABLE FOR COUNTERPARTY APPLICATIONS...
          // </p>
          <SectionHeading text="KYC IS NOT APPLICABLE FOR COUNTERPARTY APPLICATIONS..." />
        ) : (
          <p>Select Type to view the Document</p>
        )}
      </Row>

      <Row className="mt-4">
        <Col md={6}>
          <Container>
            {showSpinner ? (
              <Spinner variant="primary" animation="border" />
            ) : fileType === "pdf" ? (
              <iframe
                src={imageData}
                title="Document viewer"
                style={{ width: "550px", height: "550px" }}
              />
            ) : fileType === "img" ? (
              <Image
                src={imageData}
                style={{ width: "550px", border: "solid" }}
              />
            ) : null}
          </Container>
        </Col>
      </Row>
      {dataUpdated ? (
        <VerStatusRemarks
          selectedDocType={selectedType}
          verDocId={verDocId}
          onRefresh={refreshVerificationStatus}
        />
      ) : null}
    </>
  );
};

export default KYCVerification;
